import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { PreHeaders, Headers } from '../../models/table.model';
import { NgClass } from '@angular/common';
import { DeltaIconComponent } from '../delta-icon/delta-icon.component';
import { ValidateTableCellInputPipe } from '../../pipes/validate-table-cell-input.pipe';
import { ValidateTableCellClassPipe } from '../../pipes/validate-table-cell-class.pipe';
import { ValidateTableCellCollapsibilityPipe } from '../../pipes/validate-table-cell-collapsibility.pipe';

@Component({
    selector: 'emt-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    imports: [
        NgClass,
        DeltaIconComponent,
        ValidateTableCellInputPipe,
        ValidateTableCellClassPipe,
        ValidateTableCellCollapsibilityPipe,
    ],
})
export class TableComponent implements OnInit, OnChanges {
  @Input() preHeaders: PreHeaders[];
  @Input() headers: Headers[];
  @Input() body: Object[];
  @Input() isCollapsible: boolean;
  @Input() collapsibleKey: string;
  @Input() customTableMsg: string;
  @Output() cellClicked = new EventEmitter();
  public isDataBlank = false;
  public toggledCell: number;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.body && !this.body.length) {
      this.isDataBlank = true;
    }

    if (this.body && this.body.length) {
      this.isDataBlank = false;
    }

    this.toggledCell = null;
  }

  toggleCell(key: number) {
    if (this.toggledCell === key) {
      this.toggledCell = null;
    } else {
      this.toggledCell = key;
    }
  }

  onCellClicked(header, cell) {
    this.cellClicked.emit({ header, cell });
  }
}
